import styled from '@emotion/styled'
import { Brand } from 'app/components/Icons'
import isbot from 'isbot'
import React, { memo, useEffect, useState } from 'react'

export const Preloader = memo(function Preloader() {
  if (typeof window !== 'undefined' && isbot(navigator.userAgent)) {
    return null
  }

  const [loading, setloading] = useState(false)

  const authenticate = () => new Promise((resolve) => setTimeout(resolve, 100))

  useEffect(() => {
    history.scrollRestoration = 'manual'
    document.getElementsByTagName('main')[0].style.opacity = '0'

    authenticate().then(() => {
      setloading(true)

      setTimeout(() => {
        window.scrollTo(0, 0)
        document.getElementsByTagName('main')[0].style.opacity = '1'
        setloading(false)
      }, 1100)
    })
  }, [])

  return (
    <Container className={loading ? 'loading' : undefined}>
      <Brand />
      <Brand />
    </Container>
  )
})

const Container = styled.aside`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.colors.variants.primaryDark};
  opacity: 0;
  position: fixed;
  top: 0;
  left: 0;
  visibility: hidden;
  transition: 0.4s ease-in-out;
  z-index: -1;
  &.loading {
    opacity: 1;
    visibility: visible;
    z-index: 9999;

    svg {
      &:last-of-type {
        clip-path: inset(0);
        transition: 1.2s ease-in-out;
      }
    }
  }

  svg {
    width: 11.125rem;
    height: auto;
    fill: ${({ theme }) => theme.colors.variants.neutralDark4};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    &:last-of-type {
      clip-path: inset(100% 0% 0% 0%);
      fill: ${({ theme }) => theme.colors.variants.neutralLight5};
    }
  }

  @media (max-width: 1199px) {
    svg {
      width: 6.25rem;
    }
  }
`
